// extracted by mini-css-extract-plugin
module.exports = {"NavGroup":"style-module--NavGroup--3ELnU"};